<template>
  <div v-if="list.length > 0" class="similar">
    <h5 class="title">{{ $t('xiang-si-tui-jian') }}</h5>
    <div class="list">
      <div
        v-for="item in list"
        :key="item.id"
        class="card"
        @click="handleClick(item)"
      >
        <div class="cover">
          <XImg :src="item.cover_url" alt="cover" />
        </div>
        <div class="content">
          <div class="title">
            {{ item.name }}
          </div>
          <div class="author">
            <XImg :src="item.user_logo_url" class="author-img" alt="cover" />
            {{ displayAuthor(item) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getSimilarList } from '~/api'
import type { Loose } from '~/api/interface'
import XImg from '~/components-mobile/atom/x-img.vue'

const props = defineProps<{
  type: 'template' // 推荐的类型，template:模板
  meta: Loose // 该模式下组件的元信息
}>()

const { data } = useAsyncData(() => {
  return getSimilarList({
    template_id: props.meta.id,
  })
})

const list = computed(() => {
  return data.value?.data.results || []
})

const displayAuthor = (item: any) => {
  if (!item) {
    return ''
  }

  return item?.name_for_show || item?.homepage_org_name || item?.username
}

const handleClick = (item: any) => {
  location.href = `/m/${item.id}.html`
}
</script>

<style lang="scss" scoped>
$c1: rgba(18, 25, 38, 1);
$c2: rgba(18, 25, 38, 0.4);
$c3: rgba(18, 25, 38, 0.6);
$c4: rgba(18, 25, 38, 0.8);

.similar {
  color: $c1;
}

.title {
  font-size: m-rem(16);
  margin-bottom: m-rem(12);
}

.list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: m-rem(8);
}

.content {
  padding: 0 m-rem(8) m-rem(11);
}

.card {
  border-radius: m-rem(10);
  border: 1px solid rgb(242, 243, 243);
  overflow: hidden;
  background: #ffffff;
  .cover {
    height: 82px;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  .title {
    font-weight: 500;
    padding: 0 m-rem(8);
    font-size: m-rem(14);
    color: $c1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: m-rem(8);
  }
  .author {
    display: flex;
    align-items: center;
    color: $c2;
    font-size: m-rem(12);
  }
  .author-img {
    height: m-rem(16);
    width: m-rem(16);
    border-radius: 50%;
    margin-right: m-rem(4);
  }
}
</style>
